import {
  ATTR_MAP,
  DEFAULT_CONFIG,
  OBSERVED_ATTRIBUTES,
  type ChatWidgetConfig,
  type WidgetMessage,
  type WidgetTab,
} from "./types";
import { buildStyles } from "./styles";
import { renderMarkdown } from "./markdown";
import {
  cleanResponse,
  postEndSession,
  postVisitorInfo,
  RateLimitError,
  streamQuery,
} from "./api";
import { metadataRequestsVisitorInfo } from "./leadIntent";

const FAQ_QUESTIONS = [
  { id: 1, question: "What is AgenTriniti and what problem does it solve?", category: "AgenTriniti" },
  { id: 2, question: "What packages or tiers does AgenTriniti offer?", category: "AgenTriniti" },
  { id: 3, question: "What core services does Airo Digital Labs provide?", category: "Services" },
  { id: 4, question: "How does Airo help businesses adopt AI and generative AI?", category: "AI Solutions" },
  { id: 5, question: "What industries or use cases does Airo specialize in?", category: "Industries" },
  { id: 6, question: "Can you share success stories or case studies from Airo clients?", category: "Case Studies" },
  { id: 7, question: "How can I book a demo or talk to Airo’s sales team about AgenTriniti?", category: "Sales" },
  { id: 8, question: "How do I apply for a job at Airo Digital Labs?", category: "Careers" },
  { id: 9, question: "What open roles or career opportunities are available at Airo?", category: "Careers" },
  { id: 10, question: "How does Airo work with clients from discovery to delivery?", category: "Engagement" },
];

const NEWS = [
  {
    id: 1,
    title: "Airo Digital Labs Named an OpenAI Select Partner",
    label: "September 15, 2026",
    description: "Extends Airo’s Build, Manage, and Continuously Upgrade framework for deploying production grade enterprise AI agents to organizations adopting OpenAI’s frontier models",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-digital-labs-named-an-openai-select-partner/",
  },
  {
    id: 2,
    title: "Airolabs.ai Makes the Inc. 5000, Again. Five Years Running.",
    label: "August 14, 2026",
    description: "Five Years of Sustained Growth. One Relentless Focus: Turning AI Innovation into Business Impact.",
    cta: "Read more",
    url: "https://airolabs.ai/news/airolabs-ai-makes-the-inc-5000-again-five-years-running/",
  },
  {
    id: 3,
    title: "Airo’s Great Place to Work Story: Three Years Running",
    label: "March 27, 2026",
    description: "Airo’s Great Place to Work (GPTW) story is distinct because it embraces a high-velocity, demanding work environment while fostering a high-trust, people-first culture.",
    cta: "Read more",
    url: "https://airolabs.ai/news/airos-great-place-to-work-story-three-years-running/",
  },
  {
    id: 4,
    title: "Airolabs.ai makes the Inc. 5000, Again. And We’re Not Slowing Down.",
    label: "August 13, 2025",
    description: "Fourth year in a row. Real growth, real impact, and undeniable proof that enterprise AI has moved from experimentation to essential business strategy",
    cta: "Read more",
    url: "https://airolabs.ai/news/airolabs-ai-makes-the-inc-5000-again-and-were-not-slowing-down/",
  },
  {
    id: 5,
    title: "Airo Digital Labs makes the Inc. 5000 list for the 3rd time in a row!",
    label: "September 18, 2024",
    description: "We are thrilled to announce that Airo Digital Labs has once again secured a spot on the prestigious Inc. 5000 list of America’s fastest-growing private companies.",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-digital-labs-makes-the-inc-5000-list-for-the-3rd-time-in-a-row/",
  },
  {
    id: 6,
    title: "Chicago Based Airo Digital Labs Acquires Cloudaction to Create Top 10 fastest growing AI & Cloud Consulting Firm in the US",
    label: "April 18, 2024",
    description: "In a move poised to create Top 10 fastest growing AI & Cloud consulting firms in the US, Airo Digital Labs (Airo)..",
    cta: "Read more",
    url: "https://airolabs.ai/news/chicago-based-airo-digital-labs-acquires-cloudaction-to-create-top-10-fastest-growing-ai-cloud-consulting-firm-in-the-us/",
  },
  {
    id: 7,
    title: "Airo Digital Labs Certified as a Great Place to Work: Fostering a Culture of Excellence",
    label: "March 14, 2024",
    description: "Excellence is not just a goal at Airo, it’s a mindset. We’re proud to share that we’ve been certified by the globally renowned Great Place to Work®.",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-labs-certified-as-a-great-place-to-work-fostering-a-culture-of-excellence/",
  },
  {
    id: 8,
    title: "Airo Labs Earns Spot on Forbes’ 2024 List of America’s Best Startup Employers",
    label: "March 7, 2024",
    description: "Recognized for Employer Reputation, Employee Satisfaction, and Growth",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-digital-labs-earns-spot-on-forbes-2024-list-of-americas-best-startup-employers/",
  },
  {
    id: 9,
    title: "Airo Digital Labs Made the 2024 Inc. Regionals: Midwest List!",
    label: "February 27, 2024",
    description: "We are excited to announce that Airo Digital Labs has achieved the impressive ranking of No. 79 on the 2024 Inc. Regionals: Midwest list of the fastest-growing private companies in America!",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-digital-labs-made-the-2024-inc-regionals-midwest-list/",
  },
  {
    id: 10,
    title: "Airo Labs Joins the Prestigious New Champions Community of the World Economic Forum",
    label: "February 1, 2024",
    description: "Airo Labs is proud to announce its induction into the New Champions Community of the World Economic Forum (WEF)",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-digital-labs-joins-the-prestigious-new-champions-community-of-the-world-economic-forum/",
  },
  {
    id: 11,
    title: "Airo Digital Labs Elevates Data Capabilities as a Snowflake Select Partner",
    label: "October 26, 2023",
    description: "We are excited to announce a significant milestone in Airo Digital Labs’ journey towards empowering businesses..",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-digital-labs-elevates-data-capabilities-as-a-snowflake-select-partner/",
  },
  {
    id: 12,
    title: "Airo Digital Labs Makes the Inc. 5000 List Again in 2023!",
    label: "August 8, 2023",
    description: "We are thrilled to announce that Airo Digital Labs has once again secured a spot on the prestigious Inc. 5000 list of America’s fastest-growing private companies.",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-digital-labs-makes-the-inc-5000-list-again-in-2023/",
  },
  {
    id: 13,
    title: "Airo Digital Labs Made its Debut on the 2022 Inc. 5000 Annual List",
    label: "August 17, 2022",
    description: "With three-year revenue growth of 320%, Airo Digital Labs receives ranking no. 1893 among America’s fastest-growing private companies.",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-digital-labs-inc-5000/",
  },
  {
    id: 14,
    title: "Airo Digital Labs Founder and CEO, Dev Singh, in Conversation with HFS “Hot Vendors Fireside” Videocast",
    label: "April 4, 2022",
    description: "The HFS OneOffice Hot Vendors are a select collection of upcoming companies who have the vision and strategy to impact the market and disrupt it.",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-digital-labs-founder-and-ceo-dev-singh-in-conversation-with-hfs-hot-vendors-fireside-videocast/",
  },
  {
    id: 15,
    title: "Airo Partners with Turbotic",
    label: "February 28, 2022",
    description: "Airo Digital Labs, a Forbes-listed Chicago-based Enterprise AI enablement partner for Fortune-2000 companies, has recently collaborated with Turbotic, the world’s leading platform for the automation center of excellencies..",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-partners-with-turbotic/",
  },
  {
    id: 16,
    title: "Airo is Recognized as a Hot Vendor by HFS for Q4, 2021",
    label: "January 24, 2022",
    description: "Airo Digital Labs is proud to announce our recognition in the latest 2021 HFS Q4 Hot Vendors Report. This recognition by HFS OneOffice™ is based on Airo’s distinctiveness, ecosystem robustness, client impact, financial position..",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-is-recognized-as-a-hot-vendor-by-hfs-for-q4-2021/",
  },
  {
    id: 17,
    title: "Airo Partners with Yellow.ai",
    label: "January 13, 2022",
    description: "Airo Digital Labs, a Forbes-listed Chicago-based Enterprise AI enablement partner for Fortune-2000 companies, has recently collaborated with Yellow.ai, the world’s leading customer experience (CX) automation platform recognized as..",
    cta: "Read more",
    url: "https://airolabs.ai/news/airo-partners-with-yellow-ai/",
  },
  {
    id: 18,
    title: "OMNI Partners with AutomationEdge RPA",
    label: "November 11, 2021",
    description: "Airo Digital Labs, a Forbes-listed Chicago-based Enterprise AI enablement partner for Fortune-2000 companies, recently invited AutomationEdge to be listed on OMNI",
    cta: "Read more",
    url: "https://airolabs.ai/news/omni-partners-with-automationedge-rpa/",
  },
  {
    id: 19,
    title: "OMNI: The First-ever Platform to Launch Citizen RPA Developers",
    label: "May 12, 2021",
    description: "Robotic process automation (RPA) is the fastest-growing segment of the enterprise software market due to its many benefits – from reducing manual errors to processing tasks faster.",
    cta: "Read more",
    url: "https://airolabs.ai/news/omni-the-first-ever-platform-to-launch-citizen-rpa-developers/",
  },
  {
    id: 20,
    title: "Digital Adoption is no Longer a Need but a Much-Awaited ‘Priority’ in Healthcare",
    label: "May 6, 2021",
    description: "Traditionally, healthcare, pharma, biotech were lagging digitally. They have never been the leaders because of the regulatory environment they work in. It’s not very easy to adopt new technologies.",
    cta: "Read more",
    url: "https://airolabs.ai/news/digital-adoption-is-no-longer-a-need-but-a-much-awaited-priority-in-healthcare/",
  },
  {
    id: 21,
    title: "Today the Focus is on Devices Associated with Preventive Healthcare: Nitin Gera, Airo Digital Labs",
    label: "April 13, 2021",
    description: "In countries like the US, UK, China, the whole wearable market has grown by 288% over the last three years.",
    cta: "Read more",
    url: "https://airolabs.ai/news/today-the-focus-is-on-devices-associated-with-preventive-healthcare-nitin-gera-airo-digital-labs/",
  },
  {
    id: 22,
    title: "From Start-up to Forbes Top-1000 Growth Company in Just 36 months: The Amazing Journey of Airo!",
    label: "April 10, 2021",
    description: "Ushering in the Digital Age of Healthcare, Pharma, and Life Sciences. The following is based on an interview conducted by Tycoon Story Media of Airo Digital Labs.",
    cta: "Read more",
    url: "https://airolabs.ai/news/from-start-up-to-forbes-top-1000-growth-company-in-just-36-months-the-amazing-journey-of-airo/",
  },
  {
    id: 23,
    title: "Intelligent Automation in Healthcare an Untapped Opportunity: Dev Singh",
    label: "March 25, 2021",
    description: "So far, 2021 has turned out much better than its predecessor, there’s light at the end of this long tunnel and the Covid-19 vaccines are here. Considering the vaccination progress so far..",
    cta: "Read more",
    url: "https://airolabs.ai/news/intelligent-automation-in-healthcare-an-untapped-opportunity-dev-singh/",
  },
  {
    id: 24,
    title: "Felicitated as Best Startup Organization in the Area of Healthcare Automation",
    label: "March 21, 2021",
    description: "Airo Digital Labs has been felicitated with the award “Best start-up organization in the area of healthcare automation”, at The Healthcare Excellence Awards 2021.",
    cta: "Read more",
    url: "https://airolabs.ai/news/felicitated-as-best-startup-organization-in-the-area-of-healthcare-automation/",
  },
  {
    id: 25,
    title: "Robotic Process Automation in a Day",
    label: "March 3, 2021",
    description: "Possibilities are limitless, but time is not. Discover a better way to get things done across your organization through Digital and Robotic Process Automation.",
    cta: "Read more",
    url: "https://airolabs.ai/news/robotic-process-automation-in-a-day/",
  },
  {
    id: 26,
    title: "Our CEO & Founder, Dev Singh, is Speaking at the Future of Health Event",
    label: "March 3, 2021",
    description: "Airo Digital Labs, one of the fastest-growing leaders in the field of emerging digital technologies, is now the proud participant in the Future of Health conference..",
    cta: "Read more",
    url: "https://airolabs.ai/news/our-ceo-founder-dev-singh-is-speaking-at-the-future-of-health-event/",
  }
];

const DEFAULT_CHIPS = [
  "What is AgenTriniti and its packages?",
  "Why choose Airolabs.ai?",
  "Airo Products & Capabilities?",
  "See use cases & success stories?",
  
];

function uuid(): string {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `cw-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function formatTime(date: Date): string {
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export class ChatWidgetElement extends HTMLElement {
  static get observedAttributes() {
    return OBSERVED_ATTRIBUTES;
  }

  private config: ChatWidgetConfig = { ...DEFAULT_CONFIG };
  private root!: ShadowRoot;
  private isOpen = false;
  private activeTab: WidgetTab = "conversations";
  private messages: WidgetMessage[] = [];
  private conversationId = "";
  private visitorSubmitted = false;
  private showVisitorForm = false;
  private visitorEmail = "";
  private visitorContact = "";
  private visitorPurpose = "";
  private formError: string | null = null;
  private formSubmitting = false;
  private showSuccess = false;
  private chatEnded = false;
  private isLoading = false;
  private abortController: AbortController | null = null;
  private sessionEnded = false;
  private inputValue = "";
  /** Ignore attributeChangedCallback when we strip host `title` to kill native tooltips. */
  private clearingNativeTitle = false;

  connectedCallback() {
    this.root = this.attachShadow({ mode: "open" });
    this.syncAttributesFromDom();
    this.clearNativeTitleTooltip();
    this.initSession();
    this.render();
    window.addEventListener("pagehide", this.onPageHide);
  }

  disconnectedCallback() {
    window.removeEventListener("pagehide", this.onPageHide);
    this.abortController?.abort();
  }

  attributeChangedCallback(name: string, _old: string | null, value: string | null) {
    if (name === "title" && value === null && this.clearingNativeTitle) return;

    const key = ATTR_MAP[name];
    if (!key) return;

    // Removing host `title` must not wipe a custom header already loaded into config
    if (name === "title" && value === null) return;

    (this.config as Record<string, string>)[key] = value ?? DEFAULT_CONFIG[key];

    // Prefer header-title when both are present / updated
    if (name === "header-title" && value !== null) {
      this.config.title = value;
    }

    if (name === "title" && value !== null) {
      this.clearNativeTitleTooltip();
    }

    if (this.root) {
      if (key === "sessionId" && value) {
        this.conversationId = value;
        try {
          sessionStorage.setItem("chatbot_conversation_id", value);
        } catch {
          // ignore
        }
      }
      if (key === "userEmail" && value && !this.visitorSubmitted) {
        this.visitorEmail = value;
      }
      this.render();
    }
  }

  private syncAttributesFromDom() {
    for (const attr of OBSERVED_ATTRIBUTES) {
      const key = ATTR_MAP[attr];
      const val = this.getAttribute(attr);
      if (val !== null) {
        (this.config as Record<string, string>)[key] = val;
      }
    }
    // header-title wins over legacy title when both are set
    const headerTitle = this.getAttribute("header-title");
    if (headerTitle !== null) {
      this.config.title = headerTitle;
    }
  }

  /** Drop host `title` so browsers don't show it as a tooltip over links/panel. */
  private clearNativeTitleTooltip() {
    if (!this.hasAttribute("title")) return;
    this.clearingNativeTitle = true;
    this.removeAttribute("title");
    this.clearingNativeTitle = false;
  }

  private initSession() {
    try {
      if (sessionStorage.getItem("chatbot_visitor_submitted") === "true") {
        this.visitorSubmitted = true;
      }
      const storedEmail = sessionStorage.getItem("chatbot_visitor_email") || "";
      if (storedEmail) this.visitorEmail = storedEmail;
    } catch {
      // ignore
    }

    if (this.config.userEmail) {
      this.visitorEmail = this.config.userEmail;
      this.visitorSubmitted = true;
    }

    if (this.config.sessionId) {
      this.conversationId = this.config.sessionId;
    } else {
      try {
        let stored = sessionStorage.getItem("chatbot_conversation_id");
        if (!stored) {
          stored = uuid();
          sessionStorage.setItem("chatbot_conversation_id", stored);
        }
        this.conversationId = stored;
      } catch {
        this.conversationId = uuid();
      }
    }
  }

  private onPageHide = () => {
    void this.endChatSession();
  };

  private apiOpts() {
    return {
      apiEndpoint: this.config.apiEndpoint,
      apiKey: this.config.apiKey,
    };
  }

  private applyCssVars(host: HTMLElement) {
    const c = this.config;
    host.style.setProperty("--cw-primary", c.primaryColor);
    host.style.setProperty("--cw-primary-dark", darkenHex(c.primaryColor, 0.22));
    host.style.setProperty("--cw-bg", c.bgColor);
    host.style.setProperty("--cw-text", c.textColor);
    host.style.setProperty("--cw-radius", c.borderRadius);
    host.style.setProperty("--cw-font-family", c.fontFamily);
    host.style.setProperty("--cw-width", c.width);
    host.style.setProperty("--cw-height", c.height);
    host.style.setProperty("--cw-z", c.zIndex);

    if (c.theme === "dark") {
      host.style.setProperty("--cw-bg", c.bgColor === DEFAULT_CONFIG.bgColor ? "#111827" : c.bgColor);
      host.style.setProperty("--cw-text", c.textColor === DEFAULT_CONFIG.textColor ? "#f9fafb" : c.textColor);
    }
  }

  private ensureGreeting() {
    if (this.messages.length === 0) {
      this.messages = [
        {
          id: uuid(),
          type: "agent",
          content: this.config.greetingMessage,
          timestamp: new Date(),
          suggestionChips: [...DEFAULT_CHIPS],
        },
      ];
    }
  }

  private async endChatSession() {
    if (this.sessionEnded) return;
    const email = (this.visitorEmail || this.config.userEmail || "").trim();
    if (!email || !this.conversationId) return;
    this.sessionEnded = true;
    await postEndSession(this.apiOpts(), {
      conversation_id: this.conversationId,
      email,
      contact_no: this.visitorContact || undefined,
      purpose: this.visitorPurpose || undefined,
      user_id: this.config.userId || undefined,
    });
  }

  private openPanel() {
    this.sessionEnded = false;
    this.isOpen = true;
    this.activeTab = "conversations";
    this.ensureGreeting();
    this.render();
  }

  private minimizePanel() {
    this.isOpen = false;
    this.render();
  }

  private closeChat() {
    this.abortController?.abort();
    this.abortController = null;
    this.isLoading = false;
    void this.endChatSession();

    this.messages = [];
    this.inputValue = "";
    this.chatEnded = false;
    this.showVisitorForm = false;
    this.formError = null;
    this.formSubmitting = false;
    this.showSuccess = false;
    this.activeTab = "conversations";

    if (!this.config.sessionId) {
      this.conversationId = uuid();
      try {
        sessionStorage.setItem("chatbot_conversation_id", this.conversationId);
      } catch {
        // ignore
      }
    }

    this.sessionEnded = false;
    this.isOpen = false;
    this.render();
  }

  private setTab(tab: WidgetTab) {
    this.activeTab = tab;
    if (tab === "conversations") this.ensureGreeting();
    this.render();
  }

  private openVisitorForm(purposeHint?: string) {
    if (this.visitorSubmitted) return;
    if (purposeHint?.trim() && !this.visitorPurpose.trim()) {
      this.visitorPurpose = purposeHint.trim();
    }
    this.formError = null;
    this.showVisitorForm = true;
    this.render();
  }

  private async handleVisitorSubmit(email: string, contact: string, purpose: string) {
    this.formError = null;
    if (!email.trim()) {
      this.formError = "Email address is required.";
      this.render();
      return;
    }
    if (!this.config.apiEndpoint) {
      this.formError = "Chat API endpoint is not configured.";
      this.render();
      return;
    }

    this.formSubmitting = true;
    this.render();
    try {
      const data = await postVisitorInfo(this.apiOpts(), {
        email: email.trim(),
        contact_no: contact.trim() || undefined,
        purpose: purpose.trim() || undefined,
        conversation_id: this.conversationId,
        user_id: this.config.userId || undefined,
      });
      if (data.ok) {
        this.visitorEmail = email.trim();
        this.visitorContact = contact.trim();
        this.visitorPurpose = purpose.trim();
        if (data.conversation_id) {
          this.conversationId = data.conversation_id;
          try {
            sessionStorage.setItem("chatbot_conversation_id", this.conversationId);
          } catch {
            // ignore
          }
        }
        try {
          sessionStorage.setItem("chatbot_visitor_submitted", "true");
          sessionStorage.setItem("chatbot_visitor_email", this.visitorEmail);
        } catch {
          // ignore
        }
        this.sessionEnded = false;
        this.chatEnded = false;
        this.showSuccess = true;
        this.render();
        setTimeout(() => {
          this.visitorSubmitted = true;
          this.showVisitorForm = false;
          this.showSuccess = false;
          const followUp =
            data.follow_up_message || data.response || data.message || "";
          if (followUp.trim()) {
            this.activeTab = "conversations";
            this.messages = [
              ...this.messages,
              {
                id: uuid(),
                type: "agent",
                content: cleanResponse(followUp.trim()),
                timestamp: new Date(),
              },
            ];
          }
          this.render();
          this.scrollMessages();
        }, 700);
      } else {
        this.formError = data.detail || data.message || "Something went wrong. Please try again.";
      }
    } catch (err) {
      this.formError =
        err instanceof RateLimitError || err instanceof Error
          ? err.message
          : "Something went wrong. Please try again.";
    } finally {
      this.formSubmitting = false;
      this.render();
    }
  }

  private async sendMessage(text: string) {
    const query = text.trim();
    if (!query || this.isLoading || this.chatEnded) return;
    if (!this.config.apiEndpoint) {
      this.pushError("Chat API endpoint is not configured.");
      return;
    }

    this.abortController?.abort();
    const controller = new AbortController();
    this.abortController = controller;

    const userMsg: WidgetMessage = {
      id: uuid(),
      type: "user",
      content: query,
      timestamp: new Date(),
    };
    const agentId = uuid();
    const agentMsg: WidgetMessage = {
      id: agentId,
      type: "agent",
      content: "",
      timestamp: new Date(),
      isStreaming: true,
    };
    this.messages = [...this.messages, userMsg, agentMsg];
    this.inputValue = "";
    this.isLoading = true;
    this.activeTab = "conversations";
    this.render();
    this.scrollMessages();

    try {
      await streamQuery(
        this.apiOpts(),
        {
          query,
          conversation_id: this.conversationId,
          user_id: this.config.userId || undefined,
        },
        {
          onToken: (content) => {
            this.patchMessage(agentId, (m) => ({
              ...m,
              content: m.content + content,
            }));
            this.scrollMessages();
          },
          onMetadata: (data) => {
            if (data.conversation_id) {
              this.conversationId = data.conversation_id;
              try {
                sessionStorage.setItem("chatbot_conversation_id", this.conversationId);
              } catch {
                // ignore
              }
            }
            const raw =
              data.final_response ||
              data.response ||
              "Sorry, I couldn't find an answer to your question.";
            const chips = data.suggestion_chips;
            this.patchMessage(agentId, (m) => ({
              ...m,
              content: cleanResponse(raw),
              isStreaming: false,
              suggestionChips:
                Array.isArray(chips) && chips.length > 0 ? chips : undefined,
            }));
            if (metadataRequestsVisitorInfo(data as Record<string, unknown>)) {
              this.openVisitorForm(data.purpose || query);
            }
            this.scrollMessages();
          },
          onError: (message) => {
            this.patchMessage(agentId, (m) => ({
              ...m,
              content: message,
              isStreaming: false,
            }));
          },
        },
        controller.signal
      );

      // If stream ended still streaming with empty content
      const current = this.messages.find((m) => m.id === agentId);
      if (current?.isStreaming) {
        this.patchMessage(agentId, (m) => ({
          ...m,
          content:
            m.content ||
            "Sorry, I couldn't find an answer to your question.",
          isStreaming: false,
        }));
      }
    } catch (err) {
      if ((err as Error)?.name === "AbortError") return;
      const message =
        err instanceof RateLimitError || err instanceof Error
          ? err.message
          : "Sorry, I encountered an error processing your request. Please try again.";
      this.patchMessage(agentId, (m) => ({
        ...m,
        content: message,
        isStreaming: false,
      }));
    } finally {
      this.isLoading = false;
      this.abortController = null;
      this.render();
      this.scrollMessages();
    }
  }

  private patchMessage(id: string, fn: (m: WidgetMessage) => WidgetMessage) {
    this.messages = this.messages.map((m) => (m.id === id ? fn(m) : m));
    this.renderMessagesOnly();
  }

  private pushError(message: string) {
    this.messages = [
      ...this.messages,
      {
        id: uuid(),
        type: "agent",
        content: message,
        timestamp: new Date(),
      },
    ];
    this.render();
  }

  private scrollMessages() {
    requestAnimationFrame(() => {
      const el = this.root.querySelector(".body");
      if (el) el.scrollTop = el.scrollHeight;
    });
  }

  private renderMessagesOnly() {
    const container = this.root.querySelector("[data-messages]");
    if (!container) {
      this.render();
      return;
    }
    container.innerHTML = this.messagesHtml();
    this.bindMessageEvents(container as HTMLElement);
  }

  private messagesHtml(): string {
    return this.messages
      .map((msg) => {
        if (msg.type === "user") {
          return `
            <div class="row user">
              <div class="bubble-wrap user">
                <div class="bubble user">${escapeText(msg.content)}</div>
                <p class="meta user">${formatTime(msg.timestamp)}</p>
              </div>
              <div class="avatar">You</div>
            </div>`;
        }

        let body: string;
        if (msg.isStreaming && !msg.content) {
          body = `<div class="typing"><span></span><span></span><span></span></div>`;
        } else {
          body = renderMarkdown(cleanResponse(msg.content));
        }

        const chips =
          !this.chatEnded && msg.suggestionChips?.length
            ? `<div class="chips">${msg.suggestionChips
                .map(
                  (c, i) =>
                    `<button type="button" class="chip" data-chip="${i}" data-msg="${msg.id}">${escapeText(c)}</button>`
                )
                .join("")}</div>`
            : "";

        return `
          <div class="row agent">
            <div class="avatar">Ana</div>
            <div class="bubble-wrap">
              <p class="agent-name">Ana</p>
              <div class="bubble agent">${body}</div>
              ${chips}
              <p class="meta">${formatTime(msg.timestamp)}</p>
            </div>
          </div>`;
      })
      .join("");
  }

  private bindMessageEvents(container: HTMLElement) {
    container.querySelectorAll<HTMLButtonElement>("[data-chip]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const msgId = btn.getAttribute("data-msg");
        const idx = Number(btn.getAttribute("data-chip"));
        const msg = this.messages.find((m) => m.id === msgId);
        const chip = msg?.suggestionChips?.[idx];
        if (chip) void this.sendMessage(chip);
      });
    });
  }

  private headerTitle(): string {
    if (this.activeTab === "conversations") return this.config.title || "Chat";
    if (this.activeTab === "faqs") return "FAQ";
    return "News";
  }

  private bodyHtml(): string {
    if (this.activeTab === "faqs") {
      return `
        <div class="faq-list">
          <p class="section-label">Frequently Asked Questions</p>
          ${FAQ_QUESTIONS.map(
            (f) => `
            <button type="button" class="faq-item" data-faq="${f.id}">
              <p class="faq-q">${escapeText(f.question)}</p>
              <p class="faq-cat">${escapeText(f.category)}</p>
            </button>`
          ).join("")}
        </div>`;
    }

    if (this.activeTab === "news") {
      return `
        <div class="news-list">
          ${NEWS.map(
            (n) => `
            <a class="news-item" href="${escapeText(n.url)}" target="_blank" rel="noopener noreferrer">
              <p class="label">${escapeText(n.label)}</p>
              <h3>${escapeText(n.title)}</h3>
              <p>${escapeText(n.description)}</p>
              <span class="cta">${escapeText(n.cta)}</span>
            </a>`
          ).join("")}
        </div>`;
    }

    return `<div class="messages" data-messages>${this.messagesHtml()}</div>`;
  }

  private formOverlayHtml(): string {
    if (!this.showVisitorForm || this.visitorSubmitted || !this.isOpen) return "";
    return `
      <div class="overlay">
        <div class="form-card">
          <div class="form-header">
            <h3>Let's connect you</h3>
            <p>Share your details so our team can follow up</p>
          </div>
          <form class="form-body" data-visitor-form>
            ${
              this.formError
                ? `<div class="form-error">${escapeText(this.formError)}</div>`
                : ""
            }
            ${
              this.showSuccess
                ? `<p class="form-success">Thanks! We'll follow up soon.</p>`
                : `
              <div>
                <label>Email address <span class="req">*</span></label>
                <input type="email" name="email" required placeholder="you@example.com" value="${escapeAttr(this.visitorEmail)}" ${this.formSubmitting ? "disabled" : ""} />
              </div>
              <div>
                <label>Contact number <span class="opt">(optional)</span></label>
                <input type="tel" name="contact" placeholder="+1 234 567 8900" value="${escapeAttr(this.visitorContact)}" ${this.formSubmitting ? "disabled" : ""} />
              </div>
              <div>
                <label>What can we help with? <span class="opt">(optional)</span></label>
                <textarea name="purpose" rows="2" placeholder="e.g. Schedule a demo, talk to sales..." ${this.formSubmitting ? "disabled" : ""}>${escapeText(this.visitorPurpose)}</textarea>
              </div>
              <button type="submit" class="primary-btn" style="width:100%;border-radius:10px" ${this.formSubmitting ? "disabled" : ""}>
                ${this.formSubmitting ? "Saving..." : "Submit details"}
              </button>`
            }
          </form>
        </div>
      </div>`;
  }

  private inputBarHtml(): string {
    if (this.chatEnded) {
      return `<div class="input-bar"><p class="ended">Thank you! Your conversation has been saved. Our team may follow up if needed.</p></div>`;
    }
    if (this.activeTab !== "conversations") return "";
    return `
      <div class="input-bar">
        <div class="input-row">
          <input type="text" data-chat-input placeholder="${escapeAttr(this.config.placeholder)}" value="${escapeAttr(this.inputValue)}" ${this.isLoading ? "disabled" : ""} />
          <button type="button" class="send-btn" data-action="send" ${this.isLoading || !this.inputValue.trim() ? "disabled" : ""} aria-label="Send">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2L11 13"/><path d="M22 2L15 22l-4-9-9-4 20-7z"/></svg>
          </button>
        </div>
      </div>`;
  }

  render() {
    if (!this.root) return;
    this.applyCssVars(this);

    const posClass = `pos-${this.config.position}`;

    if (!this.isOpen) {
      this.root.innerHTML = `
        <style>${buildStyles()}</style>
        <div class="${posClass}">
          <button type="button" class="launcher" data-action="open" title="Open chat" aria-label="Open chat">
            <svg viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"/></svg>
          </button>
        </div>`;
      this.root.querySelector("[data-action='open']")?.addEventListener("click", () => this.openPanel());
      return;
    }

    this.root.innerHTML = `
      <style>${buildStyles()}</style>
      <div class="${posClass}">
        <div class="panel" style="position:fixed">
          ${this.formOverlayHtml()}
          <div class="header">
            <h2>${escapeText(this.headerTitle())}</h2>
            <div class="header-actions">
              <button type="button" class="icon-btn" data-action="minimize" title="Minimize chat" aria-label="Minimize chat">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg>
              </button>
              <button type="button" class="icon-btn" data-action="close" title="Close chat" aria-label="Close chat">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
              </button>
            </div>
          </div>
          <div class="body">${this.bodyHtml()}</div>
          ${this.inputBarHtml()}
          <div class="tabs">
            <button type="button" class="tab ${this.activeTab === "conversations" ? "active" : ""}" data-tab="conversations">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
              <span>Conversation</span>
            </button>
            <button type="button" class="tab ${this.activeTab === "faqs" ? "active" : ""}" data-tab="faqs">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>
              <span>FAQs</span>
            </button>
            <button type="button" class="tab ${this.activeTab === "news" ? "active" : ""}" data-tab="news">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 22h16a2 2 0 002-2V4a2 2 0 00-2-2H8a2 2 0 00-2 2v16a2 2 0 01-2 2zm0 0a2 2 0 01-2-2v-9c0-1.1.9-2 2-2h2"/><path d="M18 14h-8M15 18h-5M10 6h8v4h-8V6z"/></svg>
              <span>News</span>
            </button>
          </div>
        </div>
      </div>`;

    this.bindEvents();
    this.scrollMessages();
  }

  private bindEvents() {
    this.root.querySelector("[data-action='close']")?.addEventListener("click", () => this.closeChat());
    this.root.querySelector("[data-action='minimize']")?.addEventListener("click", () => this.minimizePanel());

    this.root.querySelectorAll<HTMLButtonElement>("[data-tab]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const tab = btn.getAttribute("data-tab") as WidgetTab;
        this.setTab(tab);
      });
    });

    this.root.querySelectorAll<HTMLButtonElement>("[data-faq]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = Number(btn.getAttribute("data-faq"));
        const faq = FAQ_QUESTIONS.find((f) => f.id === id);
        if (faq) {
          this.ensureGreeting();
          void this.sendMessage(faq.question);
        }
      });
    });

    const form = this.root.querySelector<HTMLFormElement>("[data-visitor-form]");
    form?.addEventListener("submit", (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      void this.handleVisitorSubmit(
        String(fd.get("email") || ""),
        String(fd.get("contact") || ""),
        String(fd.get("purpose") || "")
      );
    });

    const input = this.root.querySelector<HTMLInputElement>("[data-chat-input]");
    input?.addEventListener("input", () => {
      this.inputValue = input.value;
      const sendBtn = this.root.querySelector<HTMLButtonElement>("[data-action='send']");
      if (sendBtn) sendBtn.disabled = this.isLoading || !this.inputValue.trim();
    });
    input?.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !this.isLoading) {
        e.preventDefault();
        void this.sendMessage(this.inputValue);
      }
    });

    this.root.querySelector("[data-action='send']")?.addEventListener("click", () => {
      void this.sendMessage(this.inputValue);
    });

    const messages = this.root.querySelector("[data-messages]");
    if (messages) this.bindMessageEvents(messages as HTMLElement);
  }
}

function escapeText(value: string): string {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function escapeAttr(value: string): string {
  return escapeText(value).replace(/'/g, "&#39;");
}

function darkenHex(hex: string, amount: number): string {
  const raw = hex.replace("#", "").trim();
  if (!/^[0-9a-fA-F]{6}$/.test(raw)) return "#991b1b";
  const num = parseInt(raw, 16);
  const r = Math.max(0, Math.floor(((num >> 16) & 255) * (1 - amount)));
  const g = Math.max(0, Math.floor(((num >> 8) & 255) * (1 - amount)));
  const b = Math.max(0, Math.floor((num & 255) * (1 - amount)));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}

declare global {
  interface HTMLElementTagNameMap {
    "chat-widget": ChatWidgetElement;
  }
}
